import sanitizeHTML from 'sanitize-html';

sanitizeHTML.defaults.allowedAttributes = {
  '*': ['id', 'data-*', 'class', 'target', 'href', 'name', 'rel'],
  img: ['src', 'alt'],
};

export default sanitizeHTML;
